export default "__VITE_ASSET__Cgx8kpFa__"